import { Box, Typography } from "@mui/material";
import { StyledInfo } from "./Info.styled";
import image from "../../Images/Anja2.jpg";

export const Info = () => {
  return (
    <StyledInfo>
      <Box className="header">
        <Typography variant="h1">Info</Typography>
      </Box>
      <Box className="content">
        <Box className="imageWrapper">
          <img src={image} />
        </Box>
        <Box className="divider" />
        <Box className="text">
          <Typography variant="body1">
            Kunst in het algemeen, en schilderen in het bijzonder, is een passie
            die ik altijd al heb gevoeld, maar die ik pas enkele jaren geleden
            concreet ben beginnen te beoefenen.
          </Typography>
          <Typography variant="body1">
            Dit geeft mij zoveel voldoening omdat ik erin slaag om mijn
            innerlijke onrust over bepaalde thema's op doek over te brengen.
            Daarom is mijn kunst krachtig, energierijk en betekenisvol vanwege
            de symboliek die erachter zit.
          </Typography>
          <Typography variant="body1">
            In mijn schilderijen komen verschillende vormen, lijnen, structuren
            en abscracte figuren voor, en dit in felle kleuren. Voor elke vorm
            gebruik ik tot 4 lagen verf waardoor er in elk schilderij héél wat
            werk kruipt.
          </Typography>
          <Typography variant="body1">
            Bij de afwerking gebruik ik een stiptechniek 'dotpainting'. Het
            schilderen van stippen is zeer meditatief en rustgevend. De kleuren,
            vormen, symbolen en figuren geven een aards en inspiratief gevoel.
          </Typography>
          <Typography variant="body1">
            Laat jij je ook inspireren door mijn schilderijen!
          </Typography>
          <Typography variant="body1">Anja</Typography>
        </Box>
      </Box>
    </StyledInfo>
  );
};
